import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminReportsService {

  url = environment.url;
  constructor(private http: HttpClient) { }

  userCountData(){
    return this.http.get(this.url + '/api/adminReport/userCout');
  }


  policyCount(){
    return this.http.get(this.url + '/api/adminReport/policyCount');
  }


  SumNetpremium(){
    return this.http.get(this.url + '/api/adminReport/SumNetpremium');
  }

  UserTransacting(){
    return this.http.get(this.url + '/api/adminReport/UserTransacting');
  }

  migrate_from_insurtech_to_nonlife(data){
    return this.http.post(this.url + '/api/adminReport/migrate_from_insurtech_to_nonlife', data);
  }
}
